import $ from 'jquery';
import 'babel-polyfill';
import 'intersection-observer';

import {
  ShopSearcher,
  GalleryModal,
  NotificationManager,
} from './modules';

import initializeShared from '../shared';

import {
  initializeMarketingAssets,
  initializeUISheet,
  initializeOfferForm,
  initializeAccordion,
  initializeExpandableContent,
  initializeShopifyYCookie,
  initializeSubscriptionWithCookie,
  initializeSubscriptionPopup,
  initializeTrackListingView,
} from './initializers';

import {smoothScroll} from './utilities/smooth-scroll';
import {trackClicks as trackFacebookPixelClicks} from './utilities/facebook-pixel';
import {incrementPageCount} from './utilities/page-counter';
import {setHasOffersTransactionId} from './utilities/has-offers';

window.initMarketplace = window.initMarketplace || function() {
  initializeMarketingAssets();
  incrementPageCount();
  initializeAccordion();
  new ShopSearcher();
  new GalleryModal($('.js-gallery'));
  initializeUISheet();
  initializeOfferForm();
  initializeExpandableContent();
  initializeShared();
  trackFacebookPixelClicks();
  new NotificationManager();
  initializeShopifyYCookie();
  initializeSubscriptionWithCookie();
  initializeSubscriptionPopup();
  initializeTrackListingView();
  smoothScroll();
  setHasOffersTransactionId();
};

$(() => {
  window.initMarketplace();
  window.initMarketplace = () => {};
});
